export default __webpack_public_path__ + "static/media/loading.d09ccc04.gif";